import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '10px',
    },

    textField: {
        width: '226px',
    },

    textoObligatorios: {
        fontFamily: 'Roboto',
        fontSize: '10px',
        lineHeight: '15px',
        color: '#7E7E7E',
    },

    dropDownIcon: {
        color: '#BDBDBD',
        margin: '5px',
    },
});
